import mainTree from './mainTree/index.js';
import testTree from './test/index.js';

export default [
	mainTree,
	testTree,
]
